import { useCallback, useContext, useEffect } from 'react';
import { useEditContext } from 'react-admin';

import { AppContext } from '@app/contexts';
import { useFormLanguage } from '@app/hooks/useFormLanguage';
import { useLogoImage } from '@app/hooks/useLogoImage';
import {
  conditionalFields,
  formFields,
  nonRequiredFields,
  transformQuestionWithCallback,
} from '@app/utils/questionUtils';
import { validateConditionalFields, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import EditView from '@app/components/common/views/EditView';

import { QuestionForm } from './QuestionForm';

export const EditQuestion = () => {
  const { handleChangeLoading } = useContext(AppContext);
  const { saving } = useEditContext();
  const { language } = useFormLanguage();

  useEffect(() => {
    handleChangeLoading(!!saving);
  }, [saving, handleChangeLoading]);

  const { transform: logoTransform } = useLogoImage(nonRequiredFields);

  /**
   * Workaround to turn the responses into the format the API expects
   * TODO will need to make sure this works for multilingual payloads
   */
  const questionTransform = (values: GenericObject) => {
    return transformQuestionWithCallback(values, logoTransform, language);
  };

  const validate = useCallback((values: GenericObject) => {
    const errors = validateFormFields({ fields: formFields, values });
    const conditionalFieldsErrors = validateConditionalFields({ fields: conditionalFields, values });
    return { ...errors, ...conditionalFieldsErrors };
  }, []);

  return (
    <div>
      <EditView
        transform={questionTransform}
        resourceSingular="question"
        validate={validate}
        mutationMode="pessimistic">
        <QuestionForm title="EDIT QUESTION" />
      </EditView>
    </div>
  );
};
